import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

export default function DashboardSkeleton() {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  if (!isDesktop) {
    return (
      <Box
        sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}
        role="status"
        aria-label="Loading"
      >
        <Skeleton
          variant="rounded"
          width={112}
          height={40}
          sx={{ borderRadius: '12px' }}
        />
        <Skeleton variant="rounded" height={48} />
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} variant="rounded" height={96} />
        ))}
      </Box>
    )
  }

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
      role="status"
      aria-label="Loading"
    >
      <Box
        sx={{
          flexShrink: 0,
          px: 3,
          pt: 3,
          pb: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Skeleton
          variant="rounded"
          width={112}
          height={40}
          sx={{ borderRadius: '12px' }}
        />
        <Skeleton variant="circular" width={32} height={32} />
      </Box>
      <Box
        sx={{
          height: '100vh',
          display: 'grid',
          gridTemplateColumns: '3fr 2fr',
          gridTemplateRows: '1.2fr 1fr',
          gap: 2,
          px: 3,
          pb: 2,
        }}
      >
        {Array.from({ length: 4 }).map((_, i) => (
          <Box
            key={i}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              minHeight: 0,
            }}
          >
            <Skeleton variant="text" width={140} height={24} />
            <Skeleton
              variant="rounded"
              sx={{ flex: 1, borderRadius: '12px' }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  )
}
